import { Controller } from '@hotwired/stimulus'

// Rename a worklist via the design-system modal on the week show page.
// Registered on the `#design-system` wrapper (a common ancestor of the pencil
// buttons and the modal backdrop). `prepare` runs before `modal#open` in the
// same data-action, so the modal is pre-filled before it appears; `save`
// posts to the existing JSON `update_tag` endpoint and updates the cell name
// in place.
export default class extends Controller {
  static targets = ['label', 'input']

  prepare(event) {
    const button = event.currentTarget
    this.worklistId = button.dataset.worklistId
    this.inputTarget.value = button.dataset.worklistTag || ''

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = button.dataset.worklistLabel || ''
    }
  }

  async save() {
    const id = this.worklistId
    const tag = this.inputTarget.value
    const token = document.querySelector('meta[name="csrf-token"]').content

    try {
      const body = new URLSearchParams()
      body.append('tag', tag)
      body.append('authenticity_token', token)

      const response = await fetch(`/work_lists/${id}/update_tag`, {
        method: 'PUT',
        headers: { Accept: 'application/json', 'X-CSRF-Token': token },
        body
      })
      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      const data = await response.json()
      if (data.success) {
        const cell = document.querySelector(`td[data-work-list-id="${id}"] .full-name a`)
        if (cell) cell.textContent = data.full_name
      }

      this.close()
    } catch (error) {
      // Fall back to a reload so the user still sees the result/error.
      window.location.reload()
    }
  }

  close() {
    const modal = this.application.getControllerForElementAndIdentifier(this.element, 'modal')
    if (modal) modal.close()
  }
}
